import { combineReducers } from 'redux';
import playlistReducer from './playlistReducer';

export default combineReducers({
  playlist: playlistReducer,
});



// WEBPACK FOOTER //
// ./src/reducers/index.js